import React, { useState } from "react";
import RoomSelectionStep from "../steps/RoomSelectionStep";
import RoomAnalysisStagingStep from "../steps/RoomAnalysisStagingStep";
import { useSession } from "../../services/utils/SessionContext";
import useProductInfo from "../../services/hooks/useProductInfo";
import Loader from "../Loader";
import SmallLoader from "../SmallLoader";
const Visualiser = ({ showModal, setShowModal, images, vendorLogo }) => {
  // Set vendor color or fallback to a default color
  const vendorColor = `#${images?.vendor_color}` || "#3b1517";
  
  // State to hold the image to display (uploaded image, template image, image with highlighted sofa, or image with
  // staged sofa)
  const [image, setImage] = useState(null);
  
  // Destructuring session details from the custom hook useSession
  const { session_id, vendorUrl, product_id } = useSession();
  
  // Destructuring product info related variables from the custom hook useProductInfo
  const { productInfo, error, getProductInfo, loading: productInfoLoading, setAsSelectedProduct } = useProductInfo();
  
  // State to manage loading status for room analysis - for displaying the loader animation
  const [roomAnalysisLoading, setRoomAnalysisLoading] = useState(false);
  
  // State to manage loading status for product staging - for displaying the loader animation
  const [productStagingLoading, setproductStagingLoading] = useState(false);

  // State to manage loading status redirection to product page
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  // State to manage loading status for product staging - for displaying the loader animation
  const [interactiveSofaLoading, setInteractiveSofaLoading] = useState(false);
  
  // State to track the clicked image key - for the template images
  const [clickedImageKey, setClickedImageKey] = useState(null);

  // Function to handle image click event and fetch product info
  const handleImageClick = () => {
    getProductInfo(session_id, vendorUrl, product_id);
  };

  const screenWidthConsts = {
    mobile: 768,
    small: 1024, 
  }
  const loaderBlockStyle = window.innerWidth < screenWidthConsts.mobile ? {
    backgroundColor: vendorColor,
    border: '1px solid black',
  } : {
    backgroundColor: vendorColor,
  };


  return (
    <div
      className={`w-full h-full fixed bg-white ${
        showModal.show ? "bottom-0" : "bottom-[-100%]"
      } transition-all ease-in-out duration-500 shadow-2xl hhh overflow-auto`}
    >
      <div className="relative h-full">
        {productInfoLoading ? <Loader 
                                  title={"Fetching Product Info..."} 
                                  vendorColor={vendorColor} 
                                  loadDuration={3}
                                  loaderBlockStyle={loaderBlockStyle} /> : null}
        {roomAnalysisLoading ? <Loader 
                                  title={"Room Analysis..."} 
                                  vendorColor={vendorColor} 
                                  loadDuration={20}
                                  loaderBlockStyle={loaderBlockStyle}  /> : null}
        {productStagingLoading ? <Loader 
                                    title={"Product Staging..."} 
                                    vendorColor={vendorColor} 
                                    loadDuration={50}
                                    loaderBlockStyle={loaderBlockStyle}/> : null}
        {interactiveSofaLoading ? <SmallLoader  
                                    vendorColor={vendorColor} 
                                    loadDuration={6}  
                                    interactiveSofaLoading={interactiveSofaLoading}
                                    setInteractiveSofaLoading={setInteractiveSofaLoading}
                                    loaderBlockStyle={loaderBlockStyle}/> : null}
        <div>
          <div className="px-3 pt-3 flex justify-between items-center">
          <img
            alt="Selected Room"
            src={`data:image/png;base64,${vendorLogo}`}
            className="xl:h-16 lg:h-12 md:10 h-8 w-auto"
          />
          <button
            className="p-2"
            onClick={() => {
              window.parent.postMessage("closeIframe", "*");
              setShowModal({ ...showModal, show: false, level: 1 });
              setImage(null);
            }}
          >
            <svg
              className="w-4 md:w-6 h-4 md:h-6"
              focusable="false"
              aria-hidden="true"
              viewBox="0 0 24 24"
              data-testid="CloseIcon"
            >
              <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
            </svg>
          </button>
        </div>

        </div>

        {/* Conditional rendering based on the current step */}
        {showModal.level === 1 ? (
          <RoomSelectionStep
            setShowModal={setShowModal}
            showModal={showModal}
            images={images}
            handleImageClick={handleImageClick}
            setClickedImageKey={setClickedImageKey}
            setImage={setImage}
            vendorColor={vendorColor}
          />
        ) : (
          <RoomAnalysisStagingStep
            showModal={showModal}
            setShowModal={setShowModal}
            productInfo={productInfo}
            setAsSelectedProduct={setAsSelectedProduct}
            clickedImageKey={clickedImageKey}
            image={image}
            setRoomAnalysisLoading={setRoomAnalysisLoading}
            images={images}
            vendorColor={vendorColor}
            setproductStagingLoading={setproductStagingLoading}
            setImage={setImage}
            setInteractiveSofaLoading={setInteractiveSofaLoading}
            screenWidthConsts={screenWidthConsts}
          />
        )}
      </div>
    </div>
  );
};

export default Visualiser; // Exporting the Visualiser component as default
